import { Paper, Stack, Text } from '@mantine/core';

export default function WelcomeScreen({ flow }) {
  if (!flow) return null;

  return (
    <Paper
      p="xl"
      radius="md"
      withBorder
      style={{
        background: 'var(--aviary-surface)',
        borderLeft: '6px solid var(--mantine-color-sage-6)',
      }}
    >
      <Stack gap="md">
        <Text style={{ fontSize: 48, lineHeight: 1 }}>{flow.icon}</Text>
        <Text
          component="h2"
          fw={700}
          style={{ color: 'var(--aviary-ink)', fontSize: 28, lineHeight: 1.25, margin: 0 }}
        >
          {flow.welcome?.title}
        </Text>
        <Text size="md" style={{ color: 'var(--aviary-muted)', lineHeight: 1.5 }}>
          {flow.welcome?.body}
        </Text>
      </Stack>
    </Paper>
  );
}
